import {CityResponse, CountryResponse, HotelResponse} from "../../../../api/model/activity-hotel";
import {DateTime} from "luxon";

export const emptyHotelResponse: HotelResponse = {
    id: 1,
    hotelId: null,
    name: '',
    region: null,
    alpha2: '',
    alpha3: '',
    countryName: '',
    city: '',
    stars: ''
};

export const emptyCityResponse: CityResponse = {
    id: 1,
    name: '',
    region: null,
    alpha2: '',
    alpha3: '',
    countryName: ''
};

export const emptyCountryResponse: CountryResponse = {
    id: 1,
    name: '',
    alpha2: '',
    alpha3: ''
};

export interface DaysRange {
    startDate: DateTime
    endDate: DateTime
}

export const getDatePattern = (locale: string | string[]) => {
    const formatter = new Intl.DateTimeFormat(locale).formatToParts();
    return formatter.map(function (part) {
        switch (part.type) {
            case 'month':
                return 'MM';
            case 'day':
                return 'dd';
            case 'year':
                return 'yyyy';
            default:
                return part.value;
        }
    }).join('');
};

export const areHotelsEqual = (hotel1: HotelResponse, hotel2: HotelResponse): boolean => {
    return hotel1.id === hotel2.id &&
        hotel1.name === hotel2.name &&
        hotel1.city === hotel2.city &&
        hotel1.region === hotel2.region &&
        hotel1.alpha2 === hotel2.alpha2 &&
        hotel1.alpha3 === hotel2.alpha3 &&
        hotel1.countryName === hotel2.countryName &&
        hotel1.stars === hotel2.stars;
}




